import React from 'react';
import {
    ILimecraftPlayer,
    LimecraftEvent,
    LimecraftEventCallback,
} from '../types/limecraft';

export const useLimecraftEvent = (
    player: ILimecraftPlayer | null,
    event: LimecraftEvent,
    callback: LimecraftEventCallback,
) => {
    const savedCallback = React.useRef(callback);

    React.useEffect(() => {
        savedCallback.current = callback;
    }, [callback]);

    React.useEffect(() => {
        if (!player) return;

        const listener: LimecraftEventCallback = (data) =>
            savedCallback.current(data);

        player.addListener(event, listener);

        return () => {
            if (player) player.removeListener(event, listener);
        };
    }, [event, player]);
};
